var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlCvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.25C13.245 5.25 14.2425 4.245 14.2425 3C14.2425 1.755 13.245 0.75 12 0.75C10.755 0.75 9.75 1.755 9.75 3C9.75 4.245 10.755 5.25 12 5.25ZM6.00015 5.25C7.24515 5.25 8.24265 4.245 8.24265 3C8.24265 1.755 7.24515 0.75 6.00015 0.75C4.75515 0.75 3.75015 1.755 3.75015 3C3.75015 4.245 4.75515 5.25 6.00015 5.25ZM6 6.75002C4.2525 6.75002 0.75 7.62752 0.75 9.37502V11.25H11.25V9.37502C11.25 7.62752 7.7475 6.75002 6 6.75002ZM12.0002 6.75002C11.7827 6.75002 11.5352 6.76502 11.2727 6.78752C12.1427 7.41752 12.7502 8.26502 12.7502 9.37502V11.25H17.2502V9.37502C17.2502 7.62752 13.7477 6.75002 12.0002 6.75002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlCvr);
export default __webpack_public_path__ + "static/media/fl-cvr.71b1dc18a4d2eb5cf4873ef6231ec174.svg";
export { ForwardRef as ReactComponent };